import { Component, input, output } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-article-action-buttons',
  templateUrl: './article-action-buttons.component.html',
  styleUrls: ['./article-action-buttons.component.scss'],
  imports: [TranslatePipe],
})
export class ArticleActionButtonsComponent {
  readonly isLabeled = input<boolean>(false)
  readonly hasDownload = input<boolean>(false)
  readonly canAccess = input<boolean>(false)
  readonly canDownload = input<boolean>(false)
  readonly loading = input<boolean>(false)

  readonly download = output()
  readonly print = output()
  readonly share = output()

  onDownload(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.download.emit()
  }

  onPrint(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.print.emit()
  }

  onShare(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.share.emit()
  }

  getDownloadTitle(): string {
    if (!this.hasDownload()) {
      return 'pages.articles.actionButtons.pdfNotAvailable'
    }
    if (this.canDownload()) {
      return 'pages.articles.actionButtons.downloadAuthenticatedTooltip'
    }

    if (this.canAccess()) {
      return 'pages.articles.actionButtons.downloadRestrictedTooltip'
    }

    return 'pages.articles.actionButtons.downloadUnauthenticatedTooltip'
  }
}
